import glsl from 'babel-plugin-glsl/macro'

const fragmentShader = glsl`
    // https://www.shadertoy.com/view/4dSfDK
    #define S(a, b, t) smoothstep(a, b, t)
    #define time u_time

    uniform sampler2D u_texture;
    uniform sampler2D u_texture2;
    uniform float u_waveFactor1;
    uniform float u_waveFactor2;
    uniform vec2 u_mouse2;
    uniform vec2 u_mouse3;

    float label(vec2 p)
    {
        p *= 10.;
        // p *= 0.01;
        p.x -= 0.25;
        // p = p +  vec2(7., 3.5);
        float left = numSeven(vec2(p.x + 0.35, p.y));
        float center = numNine(vec2(p.x -0.03, p.y));
        float right = numEight(vec2(p.x - 0.42, p.y));
        return left + center + right ;
    }

    float randFloat(float x){
        return fract(sin(x) * 4748393.7585);
    }
    
    float randVec2(vec2 vUv){
        return fract(sin(dot(vUv.yx, vec2(48.48929, 76.83929))) * 727827.3738);
    }

    vec3 matrix(vec2 newCoords){
        
        float rows = 10.0;
        vec2 a;
        a = Rot(a, u_time * 10.5);
        a = floor(newCoords * rows);
        a += vec2(1., floor(u_time * 6. * randFloat(a.x)));
        vec2 b;
        // b = Rot(b, u_time * 0.5); 
        b = fract(newCoords * rows);
        float str = randVec2(a);
        float shape;
        float zero =  sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float one =   sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float two =   sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float three = sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float four =  sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float five =  sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float six =   sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float seven = sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float eight = sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
        float nine =  sdSegment(b, vec2(0.0, 0.0), vec2(0.5, 0.5));
         if(str >= 0.0 && str < 0.1 ){
            shape = zero;
        }if(str >= 0.1 && str < 0.2 ) {
            shape = one;
        }if(str >= 0.2 && str < 0.3 ) {
            shape = two;
        }if(str >= 0.3 && str < 0.4 ) {
            shape = three;
        }if(str >= 0.4 && str < 0.5 ) {
            shape = four;
        }if(str >= 0.5 && str < 0.6 ) {
            shape = five;
        }if(str >= 0.6 && str < 0.7 ) {
            shape = six;
        }if(str >= 0.7 && str < 0.8 ) {
            shape = seven;
        }if(str >= 0.8 && str < 0.9 ) {
            shape = eight;
        }if(str >= 0.9 && str < 1.0 ) {
            shape = nine;
        }
        return vec3(shape);
    }

    void main()
    {
        vec2 coords = vUv;

        vec3 color = vec3(0.);
        vec2 newCoords = coords;
        newCoords = Rot(newCoords, u_time);
        newCoords = newCoords - 0.5 ;  

        float cir = length(coords - 0.5) - 0.125;
        cir = smoothstep(0.01, 0.25, cir);
        vec2 m = u_mouse.xy;
        vec2 m2 = u_mouse2.xy;
        vec2 m3 = u_mouse3.xy;

        vec2 offset = vec2(m) - 0.5;   
        vec2 offset2 = vec2(m2) - 0.5;  
        vec2 offset3 = vec2(m3) - 0.5; 

        // newCoords = newCoords * 15. - 7.5;
        

        float an = -u_time * 0.5;
        float r1 = length(newCoords * 0.25) ;
        // r1 = abs(r1 );
        float a = -atan(newCoords.x, newCoords.y) * 0.425;
        a = abs(a * 0.735);
        newCoords = vec2(0.05/r1 + .95 + u_time * 0.25 + r1, a );

        
        vec3 grid = matrix(newCoords);
        // float shape1;
        // for (int i=1; i<=20; i++)
        //     { for(int j=1; j<=20; j++)
        //         {
        //             vec2 newUv = newCoords;
        //             newUv = Rot(vec2(newUv.x + float(i) * 1.5, newUv.y + float(j) * 1.5), sin(u_time + 0.075 * float(j * i)/4.)*4.);
        //             float line = sdSegment(vec2(newUv.x , newUv.y ), vec2(0.0), vec2(0.5 + sin(u_time * 0.125)/5.));
        //             shape1 += line;
        //         }
        //         // uv2 = uv2 * 1.1 - 0.1;
        //     }

        vec3 sample4 = texture2D(u_texture2, coords).rgb;
        
        color += grid;
        color = mix(vec3(0.), color, cir);
        
        float numLabel = label(vUv);
        color = mix(color, vec3(1.), numLabel) ;
        
        gl_FragColor = vec4(color, 1.);
    }
`

const vertexShader = glsl`
varying vec2 vUv;
uniform float u_time;
uniform vec2 u_mouse;

void main()
{
    vUv = uv;
    vec3 localSpacePosition = position;
    // gl_Position = vec4(position, 1.0);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(localSpacePosition, 1.);
}`

import { Vector2, ShaderMaterial } from 'three'
import { useRef, useEffect, useState } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import numbers from '../numLabels/numbers.js'
import preload from '../preload/preload.js'
import usefulFunctions from '../usefulFunctions/usefulFunctions.js'
import * as THREE from 'three'
import { lerp } from 'three/src/math/MathUtils.js'
import { useControls } from 'leva'
import { Text } from '@react-three/drei'


export default function Shader798()
{
    const r = './Models/EnvMaps/0/';
    const urls = [ 
        r + 'px.jpg', 
        r + 'nx.jpg',
        r + 'py.jpg', 
        r + 'ny.jpg',
        r + 'pz.jpg', 
        r + 'nz.jpg' ];

    const textureCube = new THREE.CubeTextureLoader().load(urls)

    const loader = new THREE.TextureLoader()
    const night = loader.load('./Models/Textures/photos/night.jpg')
    const forest = loader.load('./Models/Textures/photos/forest.jpg')
    const monalisa = loader.load('./Models/Textures/photos/monalisa.jpg')
    night.wrapS = THREE.MirroredRepeatWrapping
    night.wrapT = THREE.MirroredRepeatWrapping

    const DPR = Math.min(window.devicePixelRatio, 1.);

    const material = new THREE.ShaderMaterial({
        vertexShader: vertexShader ,
        fragmentShader: preload + usefulFunctions + numbers + fragmentShader,
        uniforms: {
            u_cameraPosition: {value: new THREE.Vector3()},
            u_time: { type: "f", value: 1.0 },
            u_resolution: { type: "v2", value: new Vector2(window.innerWidth, window.innerHeight) },
            u_mouse: { value: new THREE.Uniform(new THREE.Vector2()) },
            u_mouse2: { value: new THREE.Uniform(new THREE.Vector2()) },
            u_mouse3: { value: new THREE.Uniform(new THREE.Vector2()) },
            u_texture: {value: night},
            u_texture2: {value: night},
        },
    })

    const meshSize = 2

    const geometry = new THREE.PlaneGeometry(meshSize, meshSize, 256, 256)
    const meshRef = useRef()

     //mouse value 1
     let mouseX = 0;
     let mouseY = 0;
 
     //mouse value 2
     let mouseX2 = 0;
     let mouseY2 = 0;

      //mouse value 2
      let mouseX3 = 0;
      let mouseY3 = 0;

    let tempValX = 0;
    let tempValY = 0;

    let currentTime = 0

    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    const handleResize = () => {
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    let camera
    useThree((state) => {
        currentTime = state.clock.elapsedTime
        camera = state.camera
    })
    let boundingBox
    const meshSizes = {
        width: 0,
        height: 0,
        leftPixel: 0,
        rightPixel: 0,
        topPixel: 0,
        bottomPixel: 0
    }

    useEffect(() => {
        if(meshRef.current)
        {
            boundingBox = new THREE.Box3().setFromObject(meshRef.current)

            const topLeft = new THREE.Vector3(
                meshRef.current.position.x - meshSize / 2,
                meshRef.current.position.y + meshSize / 2,
                meshRef.current.position.z,
            )

            const bottomLeft = new THREE.Vector3(
                meshRef.current.position.x - meshSize / 2,
                meshRef.current.position.y - meshSize / 2,
                meshRef.current.position.z,
            )

            const topRight = new THREE.Vector3(
                meshRef.current.position.x + meshSize / 2,
                meshRef.current.position.y + meshSize / 2,
                meshRef.current.position.z,
            )

            const bottomRight = new THREE.Vector3(
                meshRef.current.position.x + meshSize / 2,
                meshRef.current.position.y - meshSize / 2,
                meshRef.current.position.z,
            )
            
            topLeft.project(camera)
            bottomLeft.project(camera)
            topRight.project(camera)
            bottomRight.project(camera)

            const topLeftX = (1 + topLeft.x) / 2 * dimensions.width
            const topLeftY = (1 - topLeft.y) / 2 * dimensions.height
            

            const bottomLeftX = (1 + bottomLeft.x) / 2 * dimensions.width
            const bottomLeftY = (1 - bottomLeft.y) / 2 * dimensions.height

            const topRightX = (1 + topRight.x) / 2 * dimensions.width
            const topRightY = (1 - topRight.y) / 2 * dimensions.height
            // console.log(topRightX, topRightY)

            const bottomRightX = (1 + bottomRight.x) / 2 * dimensions.width
            const bottomRightY = (1 - bottomRight.y) / 2 * dimensions.height

            const shaderWidth = topRightX - topLeftX
            const shaderHeight = bottomRightY - topRightY

            meshSizes.width = shaderWidth
            meshSizes.height = shaderHeight
            meshSizes.leftPixel = topLeftX

            meshSizes.rightPixel = topRightX
            meshSizes.topPixel = topLeftY
            meshSizes.bottomPixel = bottomRightY

            window.addEventListener('resize', handleResize, false)
        }
    }, [])
    
    useFrame(({clock, camera}) => {
        material.uniforms.u_cameraPosition.value = camera.position
        material.uniforms.u_time.value = clock.elapsedTime - currentTime
        material.uniforms.u_mouse.value = new Vector2(mouseX, mouseY)
        material.uniforms.u_mouse2.value = new THREE.Vector2(mouseX2, mouseY2)
        material.uniforms.u_mouse3.value = new THREE.Vector2(mouseX3, mouseY3)
        meshRef.current.material.uniforms.u_resolution.value = new THREE.Vector2(
            dimensions.width * DPR,
            dimensions.height * DPR
        )

        mouseX = lerp(mouseX, tempValX, 0.06)
        mouseY = lerp(mouseY, tempValY, 0.06)

        mouseX2 = lerp(mouseX2, tempValX, 0.05)
        mouseY2 = lerp(mouseY2, tempValY, 0.05)

        mouseX3 = lerp(mouseX3, tempValX, 0.04)
        mouseY3 = lerp(mouseY3, tempValY, 0.04)
    })

    const remap = (value, low1, high1, low2, high2 ) => {
        return low2 + (high2 - low2) * (value - low1) / (high1 - low1)
    }

    addEventListener('mousemove', (e) => {
        if(e.clientX >= meshSizes.leftPixel && e.clientX <= meshSizes.rightPixel){
            tempValX = remap(e.clientX, meshSizes.leftPixel, meshSizes.rightPixel, 0, 1)
        }
        if(e.clientY >= meshSizes.topPixel && e.clientY <= meshSizes.bottomPixel){
            tempValY = remap(e.clientY, meshSizes.topPixel, meshSizes.bottomPixel, 1, 0)
        }
    })

    addEventListener('contextmenu', e => e.preventDefault())

    addEventListener('touchmove', (e) => {
        if(e.clientX >= meshSizes.leftPixel && e.clientX <= meshSizes.rightPixel){
            tempValX = remap(e.clientX, meshSizes.leftPixel, meshSizes.rightPixel, 0, 1)
        }
        if(e.clientY >= meshSizes.topPixel && e.clientY <= meshSizes.bottomPixel){
            tempValY = remap(e.clientY, meshSizes.topPixel, meshSizes.bottomPixel, 1, 0)
        }
    }, {passive: false})

    return (
        <>
            <mesh 
                ref={meshRef} 
                geometry={geometry}
                material={material}    
            />
        </>
    )
}